<template>
  <card>
    <div class="card-header" style="display: flex;flex-direction: row;">
      <div style="margin-right: 50px;"><h4 class="card-title">Documents:</h4></div>
    </div>
    <div class="card-body">
      <div class="table-responsive" style="overflow: auto;">
        <table class="table tablesorter">
          <colgroup>
            <col style="width: 50%;">
            <col style="width: 100px;">
            <col style="width: 200px;">
            <col style="width: 150px;">
          </colgroup>
          <thead class=" text-primary">
          <tr>
            <th>
              Name
            </th>
            <th class="text-center">
              Date
            </th>
            <th>
              Information
            </th>
            <th class="text-center">
              Actions
            </th>
          </tr>
          </thead>
          <tbody id="row_docs">
          <tr v-for="(item, index) in files" :id="'tr_'+item.document_id" :key="index">
            <td>
              {{item.name.split("/").pop(-1)}}
            </td>
            <td class="text-center">
              {{item.date.split(" ")[0]}}
            </td>
            <td>
              {{item.description}}
            </td>
            <td class="td-actions text-right" style="min-width: 100px;">
              <a class="btn btn-info btn-sm btn-icon" :href="item.name" download style="font-family: 'Poppins', sans-serif; margin-right: 10px;"><i class="tim-icons icon-minimal-down"></i></a>
              <button type="button" rel="tooltip" class="btn btn-danger btn-sm btn-icon" @click="deleteDocument(item.document_id)"><i class="tim-icons icon-simple-remove"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </card>
</template>

<script>
  import {url} from "../../plugins/axios";

  export default {
    name: "table-files",
    props: ['files'],
    data(){return{url: url}},
    methods:{
      deleteDocument(id){
        const docRow = '#tr_'+id;
        this.$emit('delete-file', id, docRow);
      },
    },
  }
</script>

<style scoped>

</style>
